//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import xButton from "@/components/common/x-button.vue";
import Xcell from "@/components/common/x-cell";
import ProtocolList from "@/components/instructionProtocol/list";
import { staticType } from "./config";

export default {
  components: { xButton, Xcell, ProtocolList },
  name: "NewProtocol",
  data() {
    return {
      itemList: [],
      itemTitle: "",
      modeShow: false,
      pdfList: [],
      pdfReadStatus: false,
      isSubmit: 0
    };
  },
  props: {
    materielMap: {
      //协议内容
      type: Array,
      default() {
        return [];
      },
    },
    staticName: {
      //埋点配置信息
      type: String,
      default() {
        return "proinfo";
      },
    },
    protocolInfo: {
      type: Object,
      default() {
        return {
          productName: "",
          buyerName: "",
          insuredName: "",
        };
      },
    },
  },
  mounted() {
    this.$refs.fileList.currentValue = false;

    window.$eventBus.on('closePdf',({status, isSubmit})=>{
      this.isSubmit = isSubmit;
      // 打开弹窗
      if(status){
          this.pdfReadStatus = true; //已阅读完
          if(isSubmit){
            // 2 需要提交弹框中的 预览
            if(isSubmit===2){
              this.modeShow = true;
            }else{
              // 1 直接提交表单
              this.btnClick();
            }
          }
      }else{
        if(isSubmit){
          this.modeShow = true;
        }
      }
    })

  },
  watch: {
    modeShow() {
      if (this.modeShow) {
        // 弹窗弹出埋点
        staticType[this.staticName].showBox();
        if(Array.isArray(this.materielMap) && this.materielMap.length){
          this.onReset();
          this.materielMap.forEach(n=>{
              if(Array.isArray(n.materielList) && n.materielList.length){
                  n.materielList.forEach(m=>{
                      this.pdfList.push({
                          title: m.fileName,
                          pdf: m.shortUrl
                      })
                  })
              }
          })
        }
      }
    },
  },
  methods: {
    onReset(){
      this.pdfList = [];
      if(this.isSubmit===0){
        this.pdfReadStatus = false;
      }
    },
    // 展示弹框
    treatyClick(item) {
      if (item.materielList.length > 1) {
        this.$refs.fileList.currentValue = true;
        this.itemTitle = item.fileCategoryDesc;
        this.itemList = item.materielList;
      } else {
        this.cellClick(item.materielList[0]);
      }
      staticType[this.staticName].treatyshow();
    },
    cellClick(item) {
      if (item.shortUrl) {
        // 打开协议弹框
        this.modeShow = false;
        window.$eventBus.emit('openPdf', {
          pdfList: this.pdfList,
          isSubmit: 2
        });
        // 关闭填写投保信息弹框
        this.$emit('handle')
      } else {
        this.$toast("未获取到pdf地址");
      }
      this.$refs.fileList.currentValue = false;
    },
    btnClick() {
      // 是否已阅读完
      if(this.pdfReadStatus){
        staticType[this.staticName].check();
        staticType[this.staticName].close();
        this.modeShow = false;
        this.$emit("submitClick", true);
      }else{
        this.modeShow = false;
        window.$eventBus.emit('openPdf', {
          pdfList: this.pdfList,
          isSubmit: 1
        });
        // 关闭填写投保信息弹框
        this.$emit('handle')
      }
    },
    // 关闭弹窗
    input() {
      staticType[this.staticName].close();
      this.modeShow = false;
    },
  },
};
